import React from 'react'
import * as Fields from 'support/fields'
import { Fieldset } from 'layouts'
import { Repeater } from '@morningtrain/react-fields-repeater-field'
import * as Icons from 'ui/icons'
import { Translation } from '@morningtrain/react-translations'

export default function ChecklistTemplateForm () {
  return (
    <Fieldset>
      <Fieldset cols={2}>
        <Fields.Input
          name='name'
          label={<Translation name='fields.name.label' />}
        />
        <Fields.ResourceSelector
          name='department_id'
          optionsKey='name'
          resourceName='departments'
          operationName='select'
          label={<Translation name='fields.department.label' />}
          multiple={false}
        />
        <Fields.Select
          enum='checklist_type'
          name='type'
        />
        <Fields.Select
          enum='employment_type_category'
          name='employment_category'
          label={<Translation name='fields.category.label' />}
        />
        <Fields.Select
          enum="weekday"
          name="day"
          label={<Translation name="fields.day.label"/>}
        />
        <Fields.Time
          name="time"
          fromName="time_string"
          parseFormat="HH:mm:ss"
          label={<Translation name="fields.time.label"/>}
        />
      </Fieldset>
      <Fields.Checkbox
        name="active"
        label={<Translation name="fields.active.label"/>}
      />
      <Fields.Checkbox
        name="force"
        label={<Translation name="fields.is_forced.label"/>}
      />
      <Repeater
        name="fields"
        buttonClass="btn btn-sq btn-primary"
        addLabel={<Icons.Plus className="w-3 h-3"/>}
        removeLabel={<Icons.Trash className="w-4 h-4"/>}
      >
        <Fieldset cols={2}>
          <Fields.Input
            name="label"
            label={<Translation name="fields.name.label"/>}
          />
          <Fields.Input
            name='description'
            label={<Translation name='fields.description.label' />}
          />
        </Fieldset>
      </Repeater>
    </Fieldset>
  )
}
